<template>
  <div class="info_block">
    <h4 class="info_block_heading">{{ $t("profile.delete_account.heading") }}</h4>
    <p class="info_block_desc">{{ $t("profile.delete_account.why_explain") }}</p>
    <div class="mb-24"></div>

    <LkButton @onClick="onClick" :isSecondary="true">
      <template v-slot:prefixIcon>
        <TrashBasketIcon/>
      </template>
      {{ $t("profile.delete") }} акаунт
    </LkButton>

    <Modal 
      :isShowModal="isShowModal" 
      @onClose="isShowModal = false" 
      @showModalAfterRequest="modalCrmResponse" 
    />
    <ModalCrmResponse 
      :isShowModal="isShowModalAfterCrmResponse" 
      @onClose="isShowModalAfterCrmResponse = false" 
    />
    <DataForCRM />
  </div>
</template>

<script>
  import TrashBasketIcon from '@/shared/icons/svg/trash-basket.vue'
  import Modal from './imlp/modal/index.vue'
  import ModalCrmResponse from './imlp/modal-crm-response/index.vue'
  import DataForCRM from './imlp/data-for-crm/index.vue'

  export default {
    data: function () {
      return {
        isShowModal: false,
        isShowModalAfterCrmResponse: false
      }
    },
    components: {
      TrashBasketIcon,
      Modal,
      DataForCRM,
      ModalCrmResponse
    },
    methods: {
      onClick () {
        this.isShowModal = true
      },
      modalCrmResponse (_) {
        this.isShowModalAfterCrmResponse = _.isModalShow
      },
      modalOk () {
        this.modalClose()
      },
      modalCrissCross () {
        this.modalClose()
      },
      modalClose () {
        this.isShowModalAfterCrmResponse = false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// index.vue?d8e27c08